import React, { Component } from "react";
import PropTypes from "prop-types";

import "./TourSlider.css";

import Slider from "react-slick";

const propTypes = {
  projectId: PropTypes.number,
  slidesLength: PropTypes.number,
  completedTour: PropTypes.bool,
  setSlidesLength: PropTypes.func.isRequired,
  setCompletedTour: PropTypes.func.isRequired,
  language: PropTypes.string
};

class TourSlider extends Component {
  constructor() {
    super();

    this.slider = React.createRef();
    this.slidesLength = 0;
  }

  getSliderSettings() {
    const SETTINGS = {
      dots: true,
      adaptiveHeight: false,
      infinite: false,
      speed: 500,
      swipeToSlide: true,
      className: "tour-slider",
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      afterChange: index => {
        if (index >= this.props.slidesLength - 1 && !this.props.completedTour) {
          this.props.setCompletedTour();
        }
      }
    };

    return SETTINGS;
  }

  handleSliderRef(ref) {
    this.slider = ref;
    this.slidesLength = this.slider ? this.slider.props.children.length : 0;

    this.props.setSlidesLength(this.slidesLength);
  }

  render() {
    const SETTINGS = this.getSliderSettings();

    return (
      <Slider {...SETTINGS} ref={slider => this.handleSliderRef(slider)}>
        <div>
          <div className="pure-g">
            <div className="pure-u-1-12" />
            <div className="pure-u-5-6">
              <h3 className="textcenter">
                {"Discover games" +
                  (this.props.projectId ? " in " + this.props.projectId : "")}
              </h3>
              <p className="textcenter">
                Choose from our handpicked featured games ranging from food
                discovery, travel to education.
              </p>
            </div>
            <div className="pure-u-1-12" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img
                src="https://gametize.com/images/custom/landing/index/hero-image-events.png"
                alt=""
                className="imgresponsive"
              />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
        </div>
        <div>
          <div className="pure-g">
            <div className="pure-u-1-12" />
            <div className="pure-u-5-6">
              <h3 className="textcenter">
                {"Do challenges" +
                  (this.props.projectId ? " in " + this.props.projectId : "")}
              </h3>
              <p className="textcenter">
                Take on a wide variety of challenges. Upload photos, answer fun
                quizzes or hunt for QR codes!
              </p>
            </div>
            <div className="pure-u-1-12" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img
                src="https://gametize.com/images/custom/landing/index/hero-image-events.png"
                alt=""
                className="imgresponsive"
              />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
        </div>
        <div>
          <div className="pure-g">
            <div className="pure-u-1-12" />
            <div className="pure-u-5-6">
              <h3 className="textcenter">
                {"Collect rewards" +
                  (this.props.projectId ? " in " + this.props.projectId : "")}
              </h3>
              <p className="textcenter">
                Earn points as you complete challenges and unlock virtual items
                along the way.
              </p>
            </div>
            <div className="pure-u-1-12" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img
                src="https://gametize.com/images/custom/landing/index/hero-image-events.png"
                alt=""
                className="imgresponsive"
              />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
        </div>
        <div>
          <div className="pure-g">
            <div className="pure-u-1-12" />
            <div className="pure-u-5-6">
              <h3 className="textcenter">
                {"Browse submissions" +
                  (this.props.projectId ? " in " + this.props.projectId : "")}
              </h3>
              <p className="textcenter">
                Check out submissions by other players and vote for your
                favourites!
              </p>
            </div>
            <div className="pure-u-1-12" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img
                src="https://gametize.com/images/custom/landing/index/hero-image-events.png"
                alt=""
                className="imgresponsive"
              />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
        </div>
        <div>
          <div className="pure-g">
            <div className="pure-u-1-12" />
            <div className="pure-u-5-6">
              <h3 className="textcenter">
                {"Last slider" +
                  (this.props.projectId ? " for " + this.props.projectId : "")}
              </h3>
              <p className="textcenter">The content for the last slider.</p>
            </div>
            <div className="pure-u-1-12" />
          </div>
          <div className="pure-g">
            <div className="pure-u-1-4 pure-u-md-1-3" />
            <div className="pure-u-1-2 pure-u-md-1-3">
              <img
                src="https://gametize.com/images/custom/landing/index/hero-image-events.png"
                alt=""
                className="imgresponsive"
              />
            </div>
            <div className="pure-u-1-4 pure-u-md-1-3" />
          </div>
        </div>
      </Slider>
    );
  }
}

function NextArrow(props) {
  const { className, onClick } = props;
  return <div className={className} onClick={onClick} />;
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return <div className={className} onClick={onClick} />;
}

TourSlider.propTypes = propTypes;

export default TourSlider;
